/* UN/SET Money Move: 3D configurator (turns all the way round). Data: unset-pdp-data.js */
(function () {
  'use strict';
  /* ================================================================ options */
  var COLS = {
    none: { name: 'None', hex: null },
    offwhite: { name: 'Off-white', hex: '#ECE4D2' },
    pink: { name: 'Pink', hex: '#DE7896' },
    oxide: { name: 'Oxide', hex: '#E8522A' },
    carbon: { name: 'Carbon', hex: '#3A3734' }
  };
  var OPTS = { specs: ['none', 'offwhite', 'pink', 'oxide', 'carbon'], tie: ['pink', 'offwhite', 'oxide', 'carbon'], namec: ['offwhite', 'pink', 'oxide'] };
  var state = { specs: 'offwhite', tie: 'pink', name: '', namec: 'offwhite' };

  /* ================================================================ the photograph, its layers, and the 3D form under it (embedded) */
  function blobURL(b64, type) {
    var bin = atob(b64), u = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i);
    return URL.createObjectURL(new Blob([u], { type: type }));
  }
  function loadImg(src) { return new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = rej; im.src = src; }); }
  var ROOT = document.getElementById('unset-pdp');
  if (!ROOT || !window.UNSET_PDP_DATA || !window.THREE) return;
  var D = window.UNSET_PDP_DATA;
  var PLATE = D.plate, CUT = D.cut, MAPS = D.maps, SPECS = D.specs, AO5 = D.ao, ZF5 = D.zf;
  var PROF = D.prof, GRAIN = D.grain, LUT = D.lut, MAT = D.mat;
  var V5 = D.v5;
  // the store header sits above the stage: keep its height so the stage fills exactly the rest of the screen
  function headH() { var h = document.querySelector('.section-header'), pb = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
    ROOT.style.setProperty('--upd-hh', (h ? h.offsetHeight : 0) + 'px');
    // Shopify's preview bar (theme preview only) covers the bottom of the screen: keep the plinth above it
    var pr = pb ? pb.getBoundingClientRect() : null, ph = pr && pr.height > 0 && pr.top < innerHeight - 4 ? Math.round(innerHeight - pr.top) : 0;
    ROOT.style.setProperty('--upd-pb', Math.min(ph, 120) + 'px'); }
  headH(); window.addEventListener('resize', headH); setInterval(headH, 2000);
  // the store header slides in on scroll-up: the stage sticks just under it, so it never covers the bust
  function stickTop() { var h = document.querySelector('.section-header'), st = document.getElementById('upd-stage'); if (!st) return;
    var b = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0; if (st.__t !== b) { st.__t = b; st.style.top = b + 'px'; } }
  window.addEventListener('scroll', stickTop, { passive: true }); (function tick() { stickTop(); requestAnimationFrame(tick); })();
  var SPEC_BOX = V5.specs.box;                           // where the specs card sits, in cut-out pixels
  var PW = 1375, PH = 1144, CX = 368, CY = 163;          // the photograph, and where the cut-out sits in it
  var PX = V5.pivot[0], PZ = V5.pivot[1];                // the turning axis (cut-out px; z of the base middle)
  var R_SPECS = [190, 104, 492, 196], R_TIE = [274, 470, 397, 566], NAME_Y = 612;

  /* ================================================================ renderer: photo pixels, orthographic, exact at rest */
  var stage = document.getElementById('upd-stage'), canvas = document.getElementById('upd-gl');
  var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
  renderer.setClearColor(0x000000, 0);
  var scene = new THREE.Scene();
  var cam = new THREE.OrthographicCamera(-1, 1, 1, -1, -5000, 5000); cam.position.z = 3000;
  var BUST = null, SPEC = null, SHADOW = null, CONTACT = null, sparks = null, nameCv, nameTex, cw = 1, ch = 1;
  var U = null, DSCENE = null, DRT = null;
  var BASE_PTS = [];                                      // the footprint of the base (x, z), for shadows

  // every part turns about the base's middle; a hair of tilt follows the cursor
  var TURN_GLSL = [
    'uniform float uYaw; uniform float uTilt;',
    'vec3 turn(vec3 p) { float c = cos(uYaw), s = sin(uYaw); p = vec3(c * p.x + s * p.z, p.y, -s * p.x + c * p.z);',
    '  float ct = cos(uTilt), st = sin(uTilt); return vec3(p.x, ct * p.y - st * p.z, st * p.y + ct * p.z); }'].join('\n');
  var AO_GLSL = [
    'uniform highp sampler3D tAO; uniform vec3 uAOo; uniform vec3 uAOs;',
    'float aoAt(vec3 p, vec3 n) {',
    '  float d = texture(tAO, (p + n * 12.0 - uAOo) / uAOs).r;',
    '  float d2 = texture(tAO, (p + n * 34.0 - uAOo) / uAOs).r;',
    '  return clamp(1.0 - smoothstep(0.1, 0.65, d) * 0.45 - smoothstep(0.05, 0.5, d2) * 0.22, 0.35, 1.0);',
    '}'].join('\n');

  var SHEET_VS = [
    'attribute float aU;',
    'uniform float uPX; uniform float uCW; uniform float uCH;',
    TURN_GLSL,
    'varying vec2 vUv; varying vec3 vRest; varying vec3 vNr; varying vec3 vNw; varying float vU;',
    'void main() {',
    '  vRest = position; vNr = normal; vU = aU;',
    '  vUv = vec2((position.x + uPX) / uCW, position.y / uCH);',
    '  vNw = turn(normal);',
    '  gl_Position = projectionMatrix * modelViewMatrix * vec4(turn(position), 1.0);',
    '}'].join('\n');
  var SHEET_FS = [
    'uniform sampler2D uMap; uniform sampler2D uMaps; uniform sampler2D uName; uniform sampler2D uZF; uniform vec2 uZR;',
    'uniform float uShade; uniform vec2 uTexel; uniform vec3 uL; uniform float uTieZ;',
    'uniform sampler2D tDepth; uniform vec2 uRes; uniform float uPxD;',
    'uniform sampler2D uProf; uniform sampler2D uGrain; uniform vec3 uMean; uniform float uPX; uniform sampler2D uLut;',
    'uniform vec3 uSCA; uniform vec3 uSCB; uniform float uSA; uniform float uSB; uniform float uSweepS; uniform float uLaserS;',
    'uniform vec3 uTCA; uniform vec3 uTCB; uniform float uTA; uniform float uTB; uniform float uSweepT; uniform float uLaserT;',
    'uniform vec4 uRS; uniform vec4 uRT; uniform float uReveal; uniform float uEng; uniform float uEngGlow; uniform float uH; uniform vec3 uNameCol;',
    AO_GLSL,
    'varying vec2 vUv; varying vec3 vRest; varying vec3 vNr; varying vec3 vNw; varying float vU;',
    'float afterX(float x, float s) { return 1.0 - smoothstep(s - 0.004, s + 0.004, x); }',
    'float inRect(vec2 p, vec4 r) { return step(r.x, p.x) * step(p.x, r.z) * step(r.y, p.y) * step(p.y, r.w); }',
    // one colour for the whole bust (front photo and the rest alike): the home page hero monkey's
    'vec3 grade(vec3 c) { float l = clamp(dot(c, vec3(0.3333)), 0.0, 1.0); return texture2D(uLut, vec2(l * 0.99609 + 0.00195, 0.5)).rgb; }',
    'void main() {',
    '  if (vRest.y > uReveal) discard;',
    '  vec3 nr = normalize(vNr), N = normalize(vNw);',
    '  vec4 c = texture2D(uMap, vUv);',
    // what the photograph saw: front-facing, on the front surface, inside the cut-out
    '  float zfr = mix(uZR.x, uZR.y, texture2D(uZF, vUv).r);',
    '  float wP = smoothstep(0.03, 0.2, nr.z) * smoothstep(-16.0, -6.0, vRest.z - zfr) * smoothstep(0.2, 0.55, c.a);',
    '  vec3 m = texture2D(uMaps, vUv).rgb;',
    '  float dif = max(dot(N, uL), 0.0);',
    // ---- the photograph (exactly v3)
    '  vec3 col = c.rgb / max(c.a, .001);',
    '  float lum0 = dot(col, vec3(.333));',
    '  float aS = afterX(vUv.x, uSweepS);',
    '  float showS = mix(uSA, uSB, aS);',
    '  vec2 o = uTexel * vec2(4.0, -7.0); float sh = 0.0;',
    '  sh += texture2D(uMaps, vUv - o).g; sh += texture2D(uMaps, vUv - o * 1.6 + uTexel * vec2(3., 0.)).g;',
    '  sh += texture2D(uMaps, vUv - o * 0.6 - uTexel * vec2(3., 0.)).g; sh += texture2D(uMaps, vUv - o * 2.2).g; sh *= 0.25;',
    '  col *= 1.0 - 0.45 * sh * showS * (1.0 - uShade * 0.6);',
    '  float aT = afterX(vUv.x, uSweepT);',
    '  float showT = mix(uTA, uTB, aT); vec3 cT = mix(uTCA, uTCB, aT);',
    '  float tl = clamp((lum0 - 0.004) / 0.265, 0.0, 1.0);',
    '  vec3 tie = cT * 0.76 * (0.56 + 0.44 * min(tl / 0.34, 1.6)) + vec3(max(tl - 0.86, 0.0) * 0.1);',
    '  col = grade(col);',
    '  col = mix(col, tie, m.b * showT);',
    '  col *= mix(1.0, 1.0 + 0.12 * dif, uShade);',              // turned: the light on it moves a little, it stays the photo's black
    // ---- the rest of the piece: the same black fibreboard, lit, the cut edges catching the light
    '  float wall = 1.0 - smoothstep(0.55, 0.85, abs(nr.x));',
    '  float ed = min(vU, 1.0 - vU);',
    '  float crev = mix(1.0, mix(0.55, 1.0, smoothstep(0.0, 0.12, ed)), wall);',
    // the photo's own material: the light across one slat (groove, rounded rib, sheen) and the paint's grain
    '  vec3 slat = texture2D(uProf, vec2(clamp(vU, 0.0, 1.0), 0.5)).rgb * 2.0;',
    '  float gr = (texture2D(uGrain, vec2((vRest.x + vRest.z) / 128.0, vRest.y / 460.0)).r - 0.5) * 2.0;',   // the paint runs along the layers
    '  float sid = floor((vRest.x + uPX - 8.25) / 9.42);',
    '  float hv = fract(sin(sid * 12.9898 + 4.1) * 43758.5453);',                    // no two layers quite alike
    '  float difW = clamp((dot(N, uL) + 0.4) / 1.4, 0.0, 1.0);',
    '  vec3 Lh = normalize(vec3(0.3, 0.35, 1.0));',
    '  float difH = clamp((dot(N, Lh) + 0.3) / 1.3, 0.0, 1.0);',
    '  float shape = 0.52 + 0.56 * difH + 0.12 * difW * difW;',
    '  vec3 wallC = uMean * slat * shape * 1.22 * (0.9 + 0.2 * hv);',
    '  vec3 faceC = uMean * 1.12 * (0.32 + 0.64 * difH + 0.2 * difW * difW) * (0.95 + 0.1 * hv);',
    '  float ribw = 1.0 - smoothstep(0.88, 0.97, abs(nr.x));',          // walls and their rounded edges carry the rib
    '  vec3 pc = mix(faceC, wallC, ribw);',
    '  pc *= 1.0 + gr * 0.2;',
    '  float bev = smoothstep(0.22, 0.45, abs(nr.x)) * (1.0 - smoothstep(0.82, 0.95, abs(nr.x)));',
    // every layer's edge, found in the depth buffer: a fine bright lip on the outer layer, a soft shadow on the one behind
    '  vec2 fc = gl_FragCoord.xy / uRes, o1 = vec2(1.6, 0.0) / uRes, o2 = vec2(0.0, 1.6) / uRes;',
    '  float lip = 0.0, shd = 0.0;',
    '  if (wP < 0.98) {',
    '    float dC = texture2D(tDepth, fc).r;',
    '    float n1 = texture2D(tDepth, fc + o1).r, n2 = texture2D(tDepth, fc - o1).r, n3 = texture2D(tDepth, fc + o2).r, n4 = texture2D(tDepth, fc - o2).r;',
    '    n1 = n1 > 0.9999 ? dC : n1; n2 = n2 > 0.9999 ? dC : n2; n3 = n3 > 0.9999 ? dC : n3; n4 = n4 > 0.9999 ? dC : n4;',
    '    float dmax = max(max(n1, n2), max(n3, n4)), dmin = min(min(n1, n2), min(n3, n4));',
    '    lip = smoothstep(1.5, 5.0, (dmax - dC) / uPxD);',
    '    shd = smoothstep(1.5, 6.0, (dC - dmin) / uPxD);',
    '  }',
    '  pc = pc * (1.0 - 0.72 * shd) + uMean * 1.5 * lip * (0.45 + 0.8 * max(difW, difH));',
    '  pc += vec3(0.022, 0.024, 0.027) * pow(max(dot(N, normalize(vec3(0.75, 0.25, -0.55))), 0.0), 2.0);',
    '  pc += vec3(0.025) * pow(max(dot(reflect(-uL, N), vec3(0.0, 0.0, 1.0)), 0.0), 14.0);',
    '  float ao = wP < 0.98 ? aoAt(vRest, nr) : 1.0;',
    '  pc *= ao;',
    '  pc = grade(pc);',
    // the bow tie and its sides take the colour too
    '  float isTie = m.b * step(uTieZ, vRest.z) * showT;',
    '  pc = mix(pc, cT * (0.32 + 0.62 * dif) * crev, isTie);',
    // the name, painted across the layers of the back (read from behind)
    '  vec2 nb = vec2(1.0 - vUv.x, vUv.y);',
    '  float back = smoothstep(-0.2, -0.5, nr.z);',
    '  float e = texture2D(uName, nb).a * step(nb.x, uEng) * back;',
    '  pc = mix(pc, uNameCol * (0.62 + 0.42 * dif) * mix(0.75, 1.0, crev), e * 0.95);',
    '  vec3 outc = mix(pc, col, wP);',
    // laser light: specs and tie lines (in photo space), the build line, the name being painted
    '  vec2 px = vec2(vUv.x, 1.0 - vUv.y);',
    '  float lS = exp(-pow((vUv.x - uSweepS) / 0.0042, 2.0)) * inRect(px, uRS) * uLaserS;',
    '  float lT = exp(-pow((vUv.x - uSweepT) / 0.0042, 2.0)) * inRect(px, uRT) * uLaserT;',
    '  float lR = exp(-pow((vRest.y - uReveal) / 5.0, 2.0)) * step(uReveal, uH - 1.0);',
    '  float lE = uEngGlow * exp(-pow((nb.x - uEng) / 0.004, 2.0)) * texture2D(uName, vec2(uEng, nb.y)).a * back;',
    '  vec3 laser = vec3(1.0, 0.42, 0.18);',
    '  outc += laser * (lS * 0.25 + lT * (0.6 + 0.8 * m.b) + lR * 1.2 + lE * 1.4);',
    '  outc += vec3(1.0, 0.9, 0.8) * (lT + lR) * 0.25 * step(0.6, max(lT, lR));',
    '  float a = mix(1.0, c.a, wP);',
    '  gl_FragColor = vec4(outc * a, a);',
    '}'].join('\n');

  // the specs: a frame cut from the real specs' outline; its face shows their own light, as before
  var SPEC_VS = [
    'uniform float uPX; uniform float uCH; uniform vec4 uBox;',
    TURN_GLSL,
    'varying vec2 vCard; varying vec3 vRest; varying vec3 vNr; varying vec3 vNw;',
    'void main() {',
    '  vRest = position; vNr = normal; vNw = turn(normal);',
    '  vCard = vec2((position.x + uPX - uBox.x) / (uBox.z - uBox.x), 1.0 - ((uCH - position.y) - uBox.y) / (uBox.w - uBox.y));',
    '  gl_Position = projectionMatrix * modelViewMatrix * vec4(turn(position), 1.0);',
    '}'].join('\n');
  var SPEC_FS = [
    'uniform sampler2D uSpec; uniform float uPX; uniform float uCW; uniform vec3 uL; uniform float uShade;',
    'uniform vec3 uSCA; uniform vec3 uSCB; uniform float uSA; uniform float uSB; uniform float uSweepS; uniform float uLaserS;',
    AO_GLSL,
    'varying vec2 vCard; varying vec3 vRest; varying vec3 vNr; varying vec3 vNw;',
    'void main() {',
    '  float bx = (vRest.x + uPX) / uCW;',
    '  float aS = 1.0 - smoothstep(-0.004, 0.004, bx - uSweepS);',
    '  float show = mix(uSA, uSB, aS);',
    '  if (show < 0.5) discard;',
    '  vec3 c = mix(uSCA, uSCB, aS);',
    '  vec3 N = normalize(vNw), nr = normalize(vNr);',
    '  float dif = max(dot(N, uL), 0.0);',
    '  vec4 t = texture2D(uSpec, clamp(vCard, 0.0, 1.0));',
    '  float onCard = step(0.0, vCard.x) * step(vCard.x, 1.0) * step(0.0, vCard.y) * step(vCard.y, 1.0);',
    '  float front = smoothstep(0.55, 0.8, nr.z) * onCard * smoothstep(0.2, 0.6, t.a);',
    '  float L = t.r * 2.0;',
    '  vec3 face = c * 0.74 * L + vec3(max(L - 1.2, 0.0) * 0.18);',
    '  face *= mix(1.0, 0.88 + 0.24 * dif, uShade);',
    '  vec3 side = c * (0.36 + 0.5 * dif) * aoAt(vRest, nr);',
    '  vec3 col = mix(side, face, front);',
    '  float las = exp(-pow((bx - uSweepS) / 0.0045, 2.0)) * uLaserS;',
    '  col += vec3(1.0, 0.45, 0.2) * las * 1.3;',
    '  gl_FragColor = vec4(col, 1.0);',
    '}'].join('\n');

  // the soft shadow of the bust on the wall, leaning away from the light (anchored at the base)
  var SH_VS = 'uniform float uSkew; uniform float uH; varying vec2 vUv; varying float vWy; void main(){ vUv = uv; vec3 p = position; p.x += uSkew * clamp(p.y / uH, 0.0, 1.2) * uH; vec4 w = modelMatrix * vec4(p, 1.0); vWy = w.y; gl_Position = projectionMatrix * viewMatrix * w; }';
  var SH_FS = [
    'uniform sampler2D uMap; uniform vec2 uTexel; uniform float uO; varying vec2 vUv; varying float vWy;',
    'void main(){',
    '  float a = 0.0;',
    '  for (int i = 0; i < 12; i++) { float t = float(i) * 0.5236; vec2 d = vec2(cos(t), sin(t)) * uTexel;',
    '    a += texture2D(uMap, vUv + d * 26.0).a + texture2D(uMap, vUv + d * 52.0).a * 0.8 + texture2D(uMap, vUv + d * 84.0).a * 0.5; }',
    '  a /= 12.0 * 2.3;',
    '  a *= uO * smoothstep(-380.0, -330.0, vWy);',
    '  gl_FragColor = vec4(vec3(0.16, 0.11, 0.07) * a, a);',
    '}'].join('\n');
  // a soft contact shadow on the stone, under the base, once the bust has turned off its photographed spot
  var CT_FS = 'uniform float uO; varying vec2 vUv; void main(){ vec2 q = (vUv - 0.5) * 2.0; float a = smoothstep(1.0, 0.15, length(q * vec2(1.0, 1.0))) * uO; gl_FragColor = vec4(vec3(0.1, 0.07, 0.04) * a, a); }';

  /* ================================================================ sparks */
  function glowBlend(mt) {
    mt.blending = THREE.CustomBlending; mt.blendEquation = THREE.AddEquation;
    mt.blendSrc = THREE.OneFactor; mt.blendDst = THREE.OneFactor; mt.blendSrcAlpha = THREE.ZeroFactor; mt.blendDstAlpha = THREE.OneFactor;
  }
  function buildSparks() {
    var N = 120, pos = new Float32Array(N * 3), al = new Float32Array(N), vel = new Float32Array(N * 3), life = new Float32Array(N);
    var g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.BufferAttribute(pos, 3)); g.setAttribute('aA', new THREE.BufferAttribute(al, 1));
    var mt = new THREE.ShaderMaterial({ transparent: true, depthWrite: false, depthTest: false, uniforms: { uS: { value: 7 } },
      vertexShader: 'attribute float aA; uniform float uS; varying float vA; void main(){ vA = aA; gl_PointSize = uS * (0.5 + aA); gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0); }',
      fragmentShader: 'varying float vA; void main(){ vec2 q = gl_PointCoord - 0.5; float r = exp(-dot(q,q) * 20.0); gl_FragColor = vec4(vec3(1.0, 0.6, 0.3) * r * vA, 1.0); }' });
    glowBlend(mt);
    var m = new THREE.Points(g, mt); m.renderOrder = 9; m.frustumCulled = false; scene.add(m);
    var head = 0;
    return {
      mat: mt,
      emit: function (x, y, n, spread) {
        for (var k = 0; k < n; k++) {
          var i = head; head = (head + 1) % N;
          pos[i * 3] = x + (Math.random() - 0.5) * 3; pos[i * 3 + 1] = y + (Math.random() - 0.5) * spread; pos[i * 3 + 2] = 2000;
          vel[i * 3] = (Math.random() - 0.5) * 260; vel[i * 3 + 1] = Math.random() * 240 + 40;
          life[i] = 0.3 + Math.random() * 0.4; al[i] = 1;
        }
      },
      step: function (dt) {
        for (var i = 0; i < N; i++) {
          if (life[i] <= 0) { al[i] = 0; continue; }
          life[i] -= dt; vel[i * 3 + 1] -= 900 * dt;
          pos[i * 3] += vel[i * 3] * dt; pos[i * 3 + 1] += vel[i * 3 + 1] * dt;
          al[i] = Math.max(0, life[i] * 2);
        }
        g.attributes.position.needsUpdate = true; g.attributes.aA.needsUpdate = true;
      }
    };
  }
  // cut-out pixels (+ depth, pivot frame) -> scene, with the current turn
  function toScene(px, py, z) {
    var x = px - PX, zz = z || 0, c = Math.cos(cur.ry), s = Math.sin(cur.ry);
    return [CX + PX - PW / 2 + c * x + s * zz, PH / 2 - (CY + py)];
  }

  /* ================================================================ geometry */
  function ring(a, S) { var v = []; for (var i = 0; i < a.length; i += 2) v.push(new THREE.Vector2(a[i] / S, a[i + 1] / S)); return v; }
  function pushGeo(g, pos, nor, au, uFn) {
    var p = g.attributes.position.array, n = g.attributes.normal.array;
    for (var i = 0; i < p.length; i += 3) { pos.push(p[i], p[i + 1], p[i + 2]); nor.push(n[i], n[i + 1], n[i + 2]); if (au) au.push(uFn(p[i])); }
  }
  function buildSheets() {
    var t = V5.pitch * 0.999, bev = 1.6, pos = [], nor = [], au = [];
    V5.sheets.forEach(function (s) {
      s.polys.forEach(function (poly) {
        var shape = new THREE.Shape(ring(poly[0], V5.scale));
        for (var k = 1; k < poly.length; k++) shape.holes.push(new THREE.Path(ring(poly[k], V5.scale)));
        var g = new THREE.ExtrudeGeometry(shape, { depth: t - 2 * bev, bevelEnabled: true, bevelThickness: bev, bevelSize: bev, bevelOffset: -bev, bevelSegments: 2, curveSegments: 1 });
        g.translate(0, 0, bev); g.rotateY(-Math.PI / 2); g.translate(s.x + t / 2, 0, 0);
        if (g.index) g = g.toNonIndexed();
        pushGeo(g, pos, nor, au, function (x) { return (x - (s.x - t / 2)) / t; });
        g.dispose();
        poly[0].forEach(function () {});
        for (var i = 0; i < poly[0].length; i += 2) if (poly[0][i + 1] / V5.scale < 14) BASE_PTS.push([s.x, poly[0][i] / V5.scale]);
      });
    });
    var G = new THREE.BufferGeometry();
    G.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    G.setAttribute('normal', new THREE.Float32BufferAttribute(nor, 3));
    G.setAttribute('aU', new THREE.Float32BufferAttribute(au, 1));
    return G;
  }
  function buildSpecs() {
    var S = V5.scale, sp = V5.specs, pos = [], nor = [];
    var shape = new THREE.Shape(ring(sp.rings[0], S));
    for (var k = 1; k < sp.rings.length; k++) shape.holes.push(new THREE.Path(ring(sp.rings[k], S)));
    var g = new THREE.ExtrudeGeometry(shape, { depth: sp.t - 3, bevelEnabled: true, bevelThickness: 1.5, bevelSize: 1.5, bevelOffset: -1.5, bevelSegments: 2, curveSegments: 1 });
    g.translate(0, 0, sp.z + 1.5);
    if (g.index) g = g.toNonIndexed();
    pushGeo(g, pos, nor); g.dispose();
    sp.temples.forEach(function (pts) {
      var curve = new THREE.CatmullRomCurve3(pts.map(function (q) { return new THREE.Vector3(q[0], q[1], q[2]); }), false, 'centripetal');
      var tg = new THREE.TubeGeometry(curve, 36, 3.4, 8, false).toNonIndexed();
      pushGeo(tg, pos, nor); tg.dispose();
    });
    var G = new THREE.BufferGeometry();
    G.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    G.setAttribute('normal', new THREE.Float32BufferAttribute(nor, 3));
    return G;
  }
  function aoTexture(im) {
    var c = document.createElement('canvas'); c.width = im.width; c.height = im.height;
    var x = c.getContext('2d'); x.drawImage(im, 0, 0);
    var px = x.getImageData(0, 0, im.width, im.height).data, A = V5.ao, nx = A.n[0], ny = A.n[1], nz = A.n[2];
    var d = new Uint8Array(nx * ny * nz);
    for (var k = 0; k < nz; k++) {
      var r = Math.floor(k / A.cols), cc = k % A.cols;
      for (var y = 0; y < ny; y++) for (var i = 0; i < nx; i++) d[i + nx * (y + ny * k)] = px[((r * ny + y) * im.width + cc * nx + i) * 4];
    }
    var t = new THREE.DataTexture3D(d, nx, ny, nz);
    t.format = THREE.RedFormat; t.type = THREE.UnsignedByteType; t.minFilter = t.magFilter = THREE.LinearFilter;
    t.unpackAlignment = 1; t.needsUpdate = true;
    return t;
  }
  // how wide the base looks from the front at a turn (for the shadows)
  function baseHalfWidth(yaw) {
    var c = Math.cos(yaw), s = Math.sin(yaw), m = 0;
    for (var i = 0; i < BASE_PTS.length; i++) m = Math.max(m, Math.abs(c * BASE_PTS[i][0] + s * BASE_PTS[i][1]));
    return m;
  }

  /* ================================================================ colour changes: a laser line passes, the colour follows it */
  var PART = {
    specs: { sweep: 'uSweepS', laser: 'uLaserS', cA: 'uSCA', cB: 'uSCB', sA: 'uSA', sB: 'uSB', r: R_SPECS, vis: { hex: '#ECE4D2', show: 0 }, anim: null },
    tie: { sweep: 'uSweepT', laser: 'uLaserT', cA: 'uTCA', cB: 'uTCB', sA: 'uTA', sB: 'uTB', r: R_TIE, vis: { hex: '#DE7896', show: 0 }, anim: null }
  };
  function hexV(h) { var c = new THREE.Color(h || '#000'); return new THREE.Vector3(c.r, c.g, c.b); }
  function setPart(name, key, dur) {
    var p = PART[name]; if (!U) return;
    var hex = COLS[key].hex, show = hex ? 1 : 0;
    // the carbon bow tie is the carved one itself: no paint
    if (name === 'tie' && key === 'carbon') { show = 0; hex = p.vis.hex; }
    if (p.vis.hex === (hex || p.vis.hex) && p.vis.show === show && !p.anim) return;
    U[p.cA].value.copy(hexV(p.vis.hex)); U[p.sA].value = p.vis.show;
    U[p.cB].value.copy(hexV(hex || p.vis.hex)); U[p.sB].value = show;
    p.vis = { hex: hex || p.vis.hex, show: show };
    p.anim = { t0: performance.now(), dur: dur || 900 };
  }
  function easeIO(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  /* ================================================================ the name, painted across the back */
  var ENG = { on: false };
  function nameWidth(ctx, t, sp) { var w = 0; for (var i = 0; i < t.length; i++) w += ctx.measureText(t[i]).width + (i ? sp : 0); return w; }
  function drawName(text, fromChar) {
    var x = nameCv.getContext('2d');
    x.clearRect(0, 0, cw, ch);
    U.uNameCol.value.copy(hexV(COLS[state.namec].hex));
    if (!text) { nameTex.needsUpdate = true; ENG.on = false; U.uEng.value = 2; U.uEngGlow.value = 0; return; }
    var size = 46, sp = 7;
    x.font = '700 ' + size + 'px "Space Grotesk", sans-serif';
    while (nameWidth(x, text, sp) > 360 && size > 22) { size -= 2; x.font = '700 ' + size + 'px "Space Grotesk", sans-serif'; }
    var cx0 = cw - PX, tw = nameWidth(x, text, sp), px = cx0 - tw / 2;
    x.fillStyle = '#fff'; x.textBaseline = 'middle';
    for (var i = 0; i < text.length; i++) { x.fillText(text[i], px, NAME_Y); px += x.measureText(text[i]).width + sp; }
    nameTex.needsUpdate = true;
    var a = (cx0 - tw / 2) / cw, b = (cx0 + tw / 2) / cw;
    var from = fromChar ? (cx0 - tw / 2 + nameWidth(x, text.slice(0, fromChar), sp) + sp) / cw : a;
    ENG = { u0: from, u1: b, t0: performance.now(), dur: Math.max(220, (b - from) * cw * 7), on: true };
    U.uEng.value = from;
  }

  /* ================================================================ camera, views, drag */
  var VIEWS = { front: { ry: 0, zoom: 1, fx: 694, fy: 600 }, left: { ry: -0.75, zoom: 1, fx: 694, fy: 600 }, right: { ry: 0.75, zoom: 1, fx: 694, fy: 600 }, back: { ry: Math.PI, zoom: 1, fx: 694, fy: 600 }, face: { ry: 0.06, zoom: 1.65, fx: 700, fy: 360 } };
  var cur = { ry: 0, rx: 0, zoom: 1, fx: 694, fy: 600 }, goal = Object.assign({}, VIEWS.front), hover = { x: 0, y: 0, on: false };
  var drag = null, vel = 0, lastInput = 0, t0 = 0, built = false, SW = 1, SH = 1, Ldir = new THREE.Vector3(-0.35, 0.45, 0.82).normalize(), Lgoal = Ldir.clone();
  function nearest(target) { return target + Math.round((goal.ry - target) / (Math.PI * 2)) * Math.PI * 2; }
  function setView(v) {
    goal = Object.assign({}, VIEWS[v]); goal.ry = nearest(VIEWS[v].ry);
    ROOT.querySelectorAll('.views button').forEach(function (b) { b.classList.toggle('on', b.dataset.view === v); });
    lastInput = performance.now(); vel = 0;
  }
  ROOT.querySelectorAll('.views button').forEach(function (b) { b.addEventListener('click', function () { setView(b.dataset.view); }); });
  stage.addEventListener('pointerdown', function (e) {
    if (e.target.closest('.views')) return;
    drag = { x: e.clientX, ry: goal.ry, id: e.pointerId, moved: false, lx: e.clientX, lt: performance.now() };
    stage.classList.add('drag');
  });
  window.addEventListener('pointermove', function (e) {
    var r = stage.getBoundingClientRect();
    if (e.pointerType === 'mouse') {
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      hover.on = inside;
      if (inside) {
        hover.x = (e.clientX - r.left) / r.width * 2 - 1; hover.y = (e.clientY - r.top) / r.height * 2 - 1;
        Lgoal.set(-hover.x * 0.9 - 0.1, -hover.y * 0.7 + 0.35, 0.8).normalize();
      }
    }
    if (!drag || e.pointerId !== drag.id) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && e.pointerType !== 'mouse' && Math.abs(dx) < 6) return;
    if (!drag.moved && goal.zoom !== 1) { goal.zoom = 1; goal.fx = 694; goal.fy = 600; }
    drag.moved = true;
    var now = performance.now();
    vel = (e.clientX - drag.lx) * 0.0062 / Math.max(8, now - drag.lt) * 16; drag.lx = e.clientX; drag.lt = now;
    goal.ry = drag.ry + dx * 0.0062;
    lastInput = now;
    ROOT.querySelectorAll('.views button').forEach(function (b) { b.classList.remove('on'); });
    document.getElementById('upd-hint').classList.remove('show');
  });
  function endDrag() { drag = null; stage.classList.remove('drag'); }
  window.addEventListener('pointerup', endDrag); window.addEventListener('pointercancel', endDrag);

  function resize() {
    var r = stage.getBoundingClientRect(); SW = r.width; SH = r.height;
    renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
    renderer.setSize(SW, SH, false);
    var pr = renderer.getPixelRatio(), w = Math.max(1, Math.round(SW * pr)), h = Math.max(1, Math.round(SH * pr));
    if (!DRT) {
      DRT = new THREE.WebGLRenderTarget(w, h, { minFilter: THREE.NearestFilter, magFilter: THREE.NearestFilter });
      DRT.depthTexture = new THREE.DepthTexture(w, h); DRT.depthTexture.type = THREE.UnsignedIntType;
    } else DRT.setSize(w, h);
    if (U) { U.tDepth.value = DRT.depthTexture; U.uRes.value.set(w, h); }
  }
  if (window.ResizeObserver) new ResizeObserver(resize).observe(stage); else window.addEventListener('resize', resize);
  // cover the stage with the photograph, around a focus point, never past its edges
  // the bust with a margin (room for the view buttons above it) and the top of the plinth under it, in photo pixels:
  // whatever the stage's shape, this is never cropped; past the photograph's edges it continues, mirrored
  var NEED = [CX - 60, CY - 95, CX + 652 + 60, CY + 883 + 110];
  function clampTo(v, lo, hi) { return lo > hi ? (lo + hi) / 2 : Math.max(lo, Math.min(hi, v)); }
  function frameCamera() {
    var A = SW / SH, w, h;
    if (A >= PW / PH) { w = PW; h = PW / A; } else { h = PH; w = PH * A; }
    var nw = NEED[2] - NEED[0], nh = NEED[3] - NEED[1];
    if (h < nh) { h = nh; w = h * A; }
    if (w < nw) { w = nw; h = w / A; }
    var z = cur.zoom;
    w /= z; h /= z;
    var fx = clampTo(cur.fx, w / 2, PW - w / 2), fy = clampTo(cur.fy, h / 2, PH - h / 2);
    if (z < 1.2) { fx = clampTo(fx, NEED[2] - w / 2, NEED[0] + w / 2); fy = clampTo(fy, NEED[3] - h / 2, NEED[1] + h / 2); }
    var x0 = fx - PW / 2, y0 = PH / 2 - fy;
    cam.left = x0 - w / 2; cam.right = x0 + w / 2; cam.top = y0 + h / 2; cam.bottom = y0 - h / 2;
    cam.updateProjectionMatrix();
    return w;
  }

  /* ================================================================ loop */
  var last = performance.now(), visible = true;
  if (window.IntersectionObserver) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(stage);
  var bootT = document.getElementById('upd-bootT'), boot = document.getElementById('upd-boot');
  var REVEAL_MS = 1700, HW0 = 1;
  function frame(now) {
    requestAnimationFrame(frame);
    var dt = Math.min(0.05, (now - last) / 1000); last = now;
    if (!visible || !U) return;
    // build: the bust is cut in, layer over layer, from the stone up
    var bt = Math.min(1, (now - t0) / REVEAL_MS), be = 1 - Math.pow(1 - bt, 2.2);
    U.uReveal.value = bt >= 1 ? 1e5 : be * (ch + 4);
    if (!built) {
      bootT.textContent = 'Cutting layer ' + String(Math.round(be * 883)).padStart(3, '0') + ' / 883';
      boot.style.setProperty('--p', be);
      if (bt < 1 && Math.random() < 0.8) {
        var yy = be * ch, xs = toScene(80 + Math.random() * 500, ch - yy, 0);
        sparks.emit(xs[0], xs[1], 2, 4);
      }
      if (bt >= 1) { built = true; boot.classList.add('done'); stage.classList.add('built'); }
    }
    // turn: drag (all the way round), views, the cursor (a little), and a slow sway when left alone
    if (!drag && Math.abs(vel) > 0.0004) { goal.ry += vel; vel *= 0.92; }
    var idle = Math.min(1, Math.max(0, (now - lastInput - 5000) / 3000));
    var k = 1 - Math.pow(0.002, dt);
    var ryT = goal.ry + (hover.on && !drag ? hover.x * 0.07 : 0) + idle * 0.07 * Math.sin(now / 2400);
    var rxT = hover.on && !drag ? hover.y * 0.035 : 0;
    cur.ry += (ryT - cur.ry) * k; cur.rx += (rxT - cur.rx) * k;
    cur.zoom += (goal.zoom - cur.zoom) * k; cur.fx += (goal.fx - cur.fx) * k; cur.fy += (goal.fy - cur.fy) * k;
    var vw = frameCamera();
    sparks.mat.uniforms.uS.value = 7 * (SW / vw) * renderer.getPixelRatio() * 1.6;
    U.uYaw.value = cur.ry; U.uTilt.value = cur.rx * 0.6;
    var wrap = Math.atan2(Math.sin(cur.ry), Math.cos(cur.ry));
    U.uShade.value = Math.min(1, Math.abs(wrap) * 3.2);
    Ldir.lerp(Lgoal, 1 - Math.pow(0.05, dt)).normalize();
    // the shadows follow how wide the bust now stands
    var hw = baseHalfWidth(cur.ry) / HW0;
    SHADOW.scale.x = 0.25 + 0.75 * hw;
    SHADOW.material.uniforms.uSkew.value += ((-Ldir.x * 0.22 - wrap * 0.08) - SHADOW.material.uniforms.uSkew.value) * k;
    SHADOW.position.x = BUST.position.x + 34 - Ldir.x * 46;
    CONTACT.scale.x = baseHalfWidth(cur.ry) * 2.3; CONTACT.material.uniforms.uO.value = 0.55 * Math.min(1, Math.abs(wrap) * 4);
    // parts
    Object.keys(PART).forEach(function (n) {
      var p = PART[n];
      if (!p.anim) { U[p.laser].value += (0 - U[p.laser].value) * 0.3; return; }
      var t = Math.min(1, (now - p.anim.t0) / p.anim.dur), e = easeIO(t);
      var x0 = (p.r[0] - 6) / cw, x1 = (p.r[2] + 6) / cw, sx = x0 + (x1 - x0) * e;
      U[p.sweep].value = sx; U[p.laser].value = Math.sin(Math.PI * Math.min(1, t * 1.04));
      if (Math.random() < 0.85) { var sp = toScene(sx * cw, p.r[1] + Math.random() * (p.r[3] - p.r[1]), n === 'specs' ? V5.specs.z + V5.specs.t : U.uTieZ.value + 30); sparks.emit(sp[0], sp[1], 2, 6); }
      if (t >= 1) { p.anim = null; U[p.sweep].value = 9; }
    });
    // painting the name
    if (ENG.on) {
      var te = Math.min(1, (now - ENG.t0) / ENG.dur), ue = ENG.u0 + (ENG.u1 - ENG.u0) * te;
      U.uEng.value = ue; U.uEngGlow.value = 1;
      var ep = toScene((1 - ue) * cw, NAME_Y, -120); sparks.emit(ep[0], ep[1], 2, 8);
      if (te >= 1) { ENG.on = false; U.uEng.value = 2; U.uEngGlow.value = 0; }
    }
    sparks.step(dt);
    // depth of the layers alone (for their edges), then the picture
    U.uPxD.value = (cam.right - cam.left) / (SW * renderer.getPixelRatio()) / (cam.far - cam.near);   // depth change of one screen pixel's worth of distance
    renderer.setRenderTarget(DRT); renderer.clear(); renderer.render(DSCENE, cam); renderer.setRenderTarget(null);
    renderer.render(scene, cam);
  }

  /* ================================================================ panel */
  function roll(el, text) {
    if (!el) return;
    var c0 = el.lastElementChild; if (c0 && c0.textContent === text) return;
    var s = document.createElement('span'); s.textContent = text; s.className = 'in'; el.appendChild(s);
    if (c0) { c0.classList.add('out'); setTimeout(function () { c0.remove(); }, 650); }
    requestAnimationFrame(function () { requestAnimationFrame(function () { s.classList.remove('in'); }); });
  }
  function syncText() {
    var sp = COLS[state.specs].name, ti = COLS[state.tie].name, nm = state.name ? state.name + ' · ' + COLS[state.namec].name : '—';
    roll(ROOT.querySelector('[data-val="specs"]'), sp); roll(ROOT.querySelector('[data-val="tie"]'), ti);
    roll(ROOT.querySelector('[data-val="name"]'), state.name ? state.name : 'Optional');
    roll(ROOT.querySelector('[data-sum="specs"]'), sp); roll(ROOT.querySelector('[data-sum="tie"]'), ti); roll(ROOT.querySelector('[data-sum="name"]'), nm);
    roll(ROOT.querySelector('[data-read="specs"]'), sp); roll(ROOT.querySelector('[data-read="tie"]'), ti); roll(ROOT.querySelector('[data-read="name"]'), state.name || '—');
    document.getElementById('upd-barCfg').textContent = (state.specs === 'none' ? 'No specs' : sp + ' specs') + ' · ' + ti + ' tie' + (state.name ? ' · ' + state.name : '');
  }
  // bring the part being changed into view
  function showSide(back) {
    var want = back ? Math.PI : 0, wrap = Math.atan2(Math.sin(goal.ry - want), Math.cos(goal.ry - want));
    if (Math.abs(wrap) > (back ? 0.9 : 1.1)) { goal.ry = nearest(want); goal.zoom = 1; goal.fx = 694; goal.fy = 600; vel = 0; lastInput = performance.now();
      ROOT.querySelectorAll('.views button').forEach(function (b) { b.classList.toggle('on', b.dataset.view === (back ? 'back' : 'front')); }); }
  }
  var hoverT;
  ['specs', 'tie', 'namec'].forEach(function (part) {
    var box = ROOT.querySelector('[data-part="' + (part === 'namec' ? 'name' : part) + '"] .sw');
    OPTS[part].forEach(function (key) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', state[part] === key ? 'true' : 'false'); b.dataset.key = key;
      b.innerHTML = '<span class="chip' + (key === 'none' ? ' none' : '') + '"><i style="--c:' + (COLS[key].hex || 'transparent') + '"></i></span><span class="lbl">' + COLS[key].name + '</span>';
      b.addEventListener('click', function () {
        clearTimeout(hoverT);
        state[part] = key;
        box.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        if (part === 'namec') { showSide(true); if (U) drawName(state.name, 0); }
        else { showSide(false); setPart(part, key, 900); }
        syncText(); flashSum();
      });
      if (part === 'namec') { box.appendChild(b); return; }
      b.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || key === state[part]) return;
        clearTimeout(hoverT); hoverT = setTimeout(function () { setPart(part, key, 560); }, 110);
      });
      b.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(hoverT); hoverT = setTimeout(function () { setPart(part, state[part], 560); }, 160);
      });
      box.appendChild(b);
    });
  });
  function flashSum() { var s = document.getElementById('upd-sum'); s.classList.remove('flash'); void s.offsetWidth; s.classList.add('flash'); }
  var nameIn = document.getElementById('upd-name'), cnt = document.getElementById('upd-cnt'), nameT;
  nameIn.addEventListener('focus', function () { showSide(true); });
  nameIn.addEventListener('input', function () {
    var prev = state.name;
    var v = nameIn.value.toUpperCase().replace(/[^A-Z0-9 .&'-]/g, '').slice(0, 12);
    if (nameIn.value !== v) nameIn.value = v;
    state.name = v.trim();
    cnt.textContent = String(v.length).padStart(2, '0') + '/12';
    showSide(true);
    clearTimeout(nameT);
    nameT = setTimeout(function () {
      var from = (state.name && prev && state.name.indexOf(prev) === 0 && state.name.length > prev.length) ? prev.length : 0;
      if (U) drawName(state.name, from);
      syncText(); flashSum();
    }, 140);
  });
  var q = 1, qn = document.getElementById('upd-qn');
  document.getElementById('upd-qm').onclick = function () { q = Math.max(1, q - 1); qn.textContent = q; };
  document.getElementById('upd-qp').onclick = function () { q = Math.min(5, q + 1); qn.textContent = q; };
  var toastTO, adding = false;
  function toast(ok, text) {
    var t = document.getElementById('upd-toast');
    t.classList.toggle('err', !ok);
    t.querySelector('.mono').textContent = ok ? 'Added to cart' : 'Could not add';
    document.getElementById('upd-toastT').innerHTML = '';
    document.getElementById('upd-toastT').appendChild(document.createTextNode(text + ' '));
    if (ok) { var l = document.createElement('a'); l.href = (window.routes && window.routes.cart_url) || '/cart'; l.textContent = 'View cart →'; document.getElementById('upd-toastT').appendChild(l); }
    t.classList.add('show');
    clearTimeout(toastTO); toastTO = setTimeout(function () { t.classList.remove('show'); }, 4200);
  }
  function addToCart() {
    if (adding || ROOT.dataset.available !== 'true') return;
    adding = true;
    var btns = ROOT.querySelectorAll('.add');
    btns.forEach(function (b) { b.classList.add('busy'); });
    var props = { 'Specs': COLS[state.specs].name, 'Bow tie': COLS[state.tie].name };
    if (state.name) { props['Name on the back'] = state.name; props['Name colour'] = COLS[state.namec].name; }
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(ROOT.dataset.variant), quantity: q, properties: props }], sections: 'cart-icon-bubble', sections_url: location.pathname }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Please try again');
        var html = res.j.sections && res.j.sections['cart-icon-bubble'], bubble = document.getElementById('cart-icon-bubble');
        if (html && bubble) { var doc = new DOMParser().parseFromString(html, 'text/html'), sec = doc.querySelector('.shopify-section'); if (sec) bubble.innerHTML = sec.innerHTML; }
        btns.forEach(function (b) { b.classList.add('done'); b.querySelector('.lab').textContent = 'Added'; });
        setTimeout(function () { btns.forEach(function (b) { b.classList.remove('done'); b.querySelector('.lab').textContent = 'Add to cart'; }); }, 2600);
        toast(true, q + ' × ' + ROOT.dataset.title + ' — ' + document.getElementById('upd-barCfg').textContent + '.');
      })
      .catch(function (e) { toast(false, e.message); })
      .then(function () { adding = false; btns.forEach(function (b) { b.classList.remove('busy'); }); });
  }
  document.getElementById('upd-add').onclick = addToCart; document.getElementById('upd-add2').onclick = addToCart;
  if (ROOT.dataset.available !== 'true') ROOT.querySelectorAll('.add').forEach(function (b) { b.disabled = true; b.querySelector('.lab').textContent = 'Sold out'; });
  if (window.IntersectionObserver) new IntersectionObserver(function (e) { document.getElementById('upd-bar').classList.toggle('show', !e[0].isIntersecting); }).observe(document.getElementById('upd-buyRow'));
  ROOT.querySelectorAll('.acc details').forEach(function (d) {
    var s = d.querySelector('summary'), b = d.querySelector('.body');
    s.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.open) { b.style.height = b.scrollHeight + 'px'; requestAnimationFrame(function () { b.style.height = '0px'; }); setTimeout(function () { d.open = false; b.style.height = ''; }, 520); }
      else { d.open = true; var h = b.scrollHeight; b.style.height = '0px'; requestAnimationFrame(function () { b.style.height = h + 'px'; }); setTimeout(function () { b.style.height = ''; }, 560); }
    });
  });

  /* ================================================================ start */
  requestAnimationFrame(function () { ROOT.classList.add('ready'); });
  ROOT.querySelectorAll('[data-rise]').forEach(function (el, i) { el.style.transitionDelay = (0.25 + i * 0.07) + 's'; });
  syncText();
  function tex(im, premult) { var t = new THREE.Texture(im); t.premultiplyAlpha = !!premult; t.minFilter = THREE.LinearFilter; t.generateMipmaps = false; t.needsUpdate = true; return t; }
  Promise.all([loadImg(blobURL(PLATE, 'image/webp')), loadImg(blobURL(CUT, 'image/webp')), loadImg(blobURL(MAPS, 'image/png')), loadImg(blobURL(SPECS, 'image/png')),
    loadImg(blobURL(AO5, 'image/png')), loadImg(blobURL(ZF5, 'image/png')), loadImg(blobURL(PROF, 'image/png')), loadImg(blobURL(GRAIN, 'image/png')), loadImg(blobURL(LUT, 'image/png')),
    document.fonts ? Promise.all([document.fonts.load('600 22px "IBM Plex Mono"'), document.fonts.load('700 46px "Space Grotesk"')]).catch(function () { return 0; }) : 0]).then(function (r) {
    var plateIm = r[0], cutIm = r[1], mapIm = r[2], specIm = r[3], aoIm = r[4], zfIm = r[5], profIm = r[6], grainIm = r[7], lutIm = r[8];
    cw = cutIm.naturalWidth; ch = cutIm.naturalHeight;
    // the photograph
    // the photograph, continued mirrored on every side (wide or tall stages see a little past its edges)
    var pg = new THREE.PlaneGeometry(PW * 3, PH * 3), puv = pg.attributes.uv;
    for (var pi = 0; pi < puv.count; pi++) puv.setXY(pi, puv.getX(pi) * 3 - 1, puv.getY(pi) * 3 - 1);
    var plateT = tex(plateIm); plateT.wrapS = plateT.wrapT = THREE.MirroredRepeatWrapping;
    var plate = new THREE.Mesh(pg, new THREE.MeshBasicMaterial({ map: plateT, depthTest: false, depthWrite: false }));
    plate.renderOrder = -3; scene.add(plate);
    var cutT = tex(cutIm, true), mapT = tex(mapIm), zfT = tex(zfIm);
    nameCv = document.createElement('canvas'); nameCv.width = cw; nameCv.height = ch;
    nameTex = new THREE.CanvasTexture(nameCv); nameTex.minFilter = THREE.LinearFilter; nameTex.generateMipmaps = false;
    var base = [CX + PX - PW / 2, PH / 2 - (CY + ch)];          // the turning axis, at the bottom of the cut-out
    // wall shadow
    var su = { uMap: { value: cutT }, uTexel: { value: new THREE.Vector2(1 / cw, 1 / ch) }, uO: { value: 0.0 }, uSkew: { value: -0.05 }, uH: { value: ch } };
    var sg = new THREE.PlaneGeometry(cw, ch, 1, 8); sg.translate(0, ch / 2, 0);
    SHADOW = new THREE.Mesh(sg, new THREE.ShaderMaterial({ uniforms: su, vertexShader: SH_VS, fragmentShader: SH_FS, transparent: true, depthTest: false, depthWrite: false }));
    SHADOW.material.premultipliedAlpha = true; SHADOW.renderOrder = -2; SHADOW.position.set(base[0] + 14, base[1] + 6, -10); scene.add(SHADOW);
    // contact shadow on the stone
    var cg = new THREE.PlaneGeometry(1, 46);
    CONTACT = new THREE.Mesh(cg, new THREE.ShaderMaterial({ uniforms: { uO: { value: 0 } }, vertexShader: 'varying vec2 vUv; void main(){ vUv = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0); }', fragmentShader: CT_FS, transparent: true, depthTest: false, depthWrite: false }));
    CONTACT.material.premultipliedAlpha = true; CONTACT.renderOrder = -1; CONTACT.position.set(base[0], base[1] + 4, -5); scene.add(CONTACT);
    // the bust: the 3D form, wearing the photograph where the photograph saw it
    var shirtZ = 102 - PZ + 4;
    U = { uMap: { value: cutT }, uMaps: { value: mapT }, uName: { value: nameTex }, uZF: { value: zfT }, uZR: { value: new THREE.Vector2(V5.zr[0], V5.zr[1]) },
      tAO: { value: aoTexture(aoIm) }, uAOo: { value: new THREE.Vector3(V5.ao.o[0], V5.ao.o[1], V5.ao.o[2]) },
      uAOs: { value: new THREE.Vector3(V5.ao.s * V5.ao.n[0], V5.ao.s * V5.ao.n[1], V5.ao.s * V5.ao.n[2]) },
      uProf: { value: (function () { var t = tex(profIm); t.wrapS = THREE.ClampToEdgeWrapping; return t; })() },
      uGrain: { value: (function () { var t = tex(grainIm); t.wrapS = t.wrapT = THREE.MirroredRepeatWrapping; t.minFilter = THREE.LinearFilter; return t; })() },
      uMean: { value: new THREE.Vector3(MAT.mean[0], MAT.mean[1], MAT.mean[2]) },
      uLut: { value: (function () { var t = tex(lutIm); t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping; return t; })() },
      tDepth: { value: null }, uRes: { value: new THREE.Vector2(1, 1) }, uPxD: { value: 1e-4 },
      uPX: { value: PX }, uCW: { value: cw }, uCH: { value: ch }, uYaw: { value: 0 }, uTilt: { value: 0 }, uL: { value: Ldir }, uShade: { value: 0 },
      uTexel: { value: new THREE.Vector2(1 / cw, 1 / ch) }, uH: { value: ch }, uTieZ: { value: shirtZ },
      uReveal: { value: 0 }, uEng: { value: 2 }, uEngGlow: { value: 0 }, uNameCol: { value: hexV(COLS.offwhite.hex) },
      uSCA: { value: hexV(COLS.offwhite.hex) }, uSCB: { value: hexV(COLS.offwhite.hex) }, uSA: { value: 0 }, uSB: { value: 0 }, uSweepS: { value: 9 }, uLaserS: { value: 0 },
      uTCA: { value: hexV(COLS.pink.hex) }, uTCB: { value: hexV(COLS.pink.hex) }, uTA: { value: 0 }, uTB: { value: 0 }, uSweepT: { value: 9 }, uLaserT: { value: 0 },
      uRS: { value: new THREE.Vector4(R_SPECS[0] / cw, R_SPECS[1] / ch, R_SPECS[2] / cw, R_SPECS[3] / ch) },
      uRT: { value: new THREE.Vector4(R_TIE[0] / cw, R_TIE[1] / ch, R_TIE[2] / cw, R_TIE[3] / ch) } };
    var mat = new THREE.ShaderMaterial({ vertexShader: SHEET_VS, fragmentShader: SHEET_FS, uniforms: U, transparent: true, depthTest: true, depthWrite: true });
    mat.premultipliedAlpha = true;
    var sheetGeo = buildSheets();
    BUST = new THREE.Mesh(sheetGeo, mat); BUST.position.set(base[0], base[1], 0); BUST.frustumCulled = false; scene.add(BUST);
    // depth first (cheap), so the full shading runs once per pixel even when 60 layers stand behind each other
    var pre = new THREE.Mesh(sheetGeo, new THREE.ShaderMaterial({ vertexShader: SHEET_VS, uniforms: U, colorWrite: false, depthWrite: true, polygonOffset: true, polygonOffsetFactor: 1.5, polygonOffsetUnits: 4,
      fragmentShader: 'uniform float uReveal; varying vec3 vRest; void main(){ if (vRest.y > uReveal) discard; gl_FragColor = vec4(0.0); }' }));
    pre.position.copy(BUST.position); pre.frustumCulled = false; pre.renderOrder = -5; scene.add(pre);
    DSCENE = new THREE.Scene();
    var dmesh = new THREE.Mesh(sheetGeo, new THREE.ShaderMaterial({ vertexShader: SHEET_VS, uniforms: U,
      fragmentShader: 'uniform float uReveal; varying vec3 vRest; void main(){ if (vRest.y > uReveal) discard; gl_FragColor = vec4(1.0); }' }));
    dmesh.position.copy(BUST.position); dmesh.frustumCulled = false; DSCENE.add(dmesh);
    HW0 = baseHalfWidth(0) || 1;
    // the specs
    var su2 = { uSpec: { value: tex(specIm) }, uBox: { value: new THREE.Vector4(SPEC_BOX[0], SPEC_BOX[1], SPEC_BOX[2], SPEC_BOX[3]) },
      uPX: U.uPX, uCW: U.uCW, uCH: U.uCH, uYaw: U.uYaw, uTilt: U.uTilt, uL: U.uL, uShade: U.uShade, tAO: U.tAO, uAOo: U.uAOo, uAOs: U.uAOs,
      uSCA: U.uSCA, uSCB: U.uSCB, uSA: U.uSA, uSB: U.uSB, uSweepS: U.uSweepS, uLaserS: U.uLaserS };
    SPEC = new THREE.Mesh(buildSpecs(), new THREE.ShaderMaterial({ vertexShader: SPEC_VS, fragmentShader: SPEC_FS, uniforms: su2, depthTest: true, depthWrite: true }));
    SPEC.position.copy(BUST.position); SPEC.frustumCulled = false; SPEC.renderOrder = 2; scene.add(SPEC);
    sparks = buildSparks();
    resize();
    t0 = performance.now(); lastInput = t0;
    // the shadow fades in with the bust; then the specs and the tie are cut in
    var fadeSh = function () { var k = Math.min(1, (performance.now() - t0) / 2400); su.uO.value = 0.16 * k; if (k < 1) requestAnimationFrame(fadeSh); };
    fadeSh();
    setTimeout(function () { setPart('specs', state.specs, 1000); }, REVEAL_MS + 150);
    setTimeout(function () { setPart('tie', state.tie, 800); }, REVEAL_MS + 900);
    setTimeout(function () { document.getElementById('upd-hint').classList.add('show'); }, REVEAL_MS + 1700);
    requestAnimationFrame(frame);
  });
})();
